export default __webpack_public_path__ + "static/media/avatar3.275a95b9.svg";